import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_25 = { class: "control-label col-sm-6" }
const _hoisted_26 = { class: "col-sm" }
const _hoisted_27 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_28 = { class: "control-label col-sm-6" }
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_31 = { class: "control-label col-sm-6" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_34 = { class: "control-label col-sm-6" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_44 = { class: "control-label col-sm-6" }
const _hoisted_45 = { class: "col-sm" }
const _hoisted_46 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_47 = { class: "control-label col-sm-6" }
const _hoisted_48 = { class: "col-sm" }
const _hoisted_49 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_50 = { class: "control-label col-sm-6" }
const _hoisted_51 = { class: "col-sm" }
const _hoisted_52 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_53 = { class: "control-label col-sm-6" }
const _hoisted_54 = { class: "col-sm" }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_57 = { class: "control-label col-sm-6" }
const _hoisted_58 = { class: "col-sm" }
const _hoisted_59 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_60 = { class: "control-label col-sm-6" }
const _hoisted_61 = { class: "col-sm" }
const _hoisted_62 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_63 = { class: "control-label col-sm-6" }
const _hoisted_64 = { class: "col-sm" }
const _hoisted_65 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_66 = { class: "control-label col-sm-6" }
const _hoisted_67 = { class: "col-sm" }
const _hoisted_68 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_69 = { class: "control-label col-sm-6" }
const _hoisted_70 = { class: "col-sm" }
const _hoisted_71 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_72 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_73 = { class: "col-sm" }
const _hoisted_74 = {
  key: 3,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_75 = { class: "control-label col-sm-6" }
const _hoisted_76 = { class: "col-sm" }
const _hoisted_77 = {
  key: 4,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_78 = { class: "control-label col-sm-6" }
const _hoisted_79 = { class: "col-sm" }
const _hoisted_80 = {
  key: 5,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_81 = { class: "control-label col-sm-6" }
const _hoisted_82 = { class: "col-sm" }
const _hoisted_83 = {
  key: 6,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_84 = { class: "control-label col-sm-6" }
const _hoisted_85 = { class: "col-sm" }
const _hoisted_86 = {
  key: 7,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_87 = { class: "control-label col-sm-6" }
const _hoisted_88 = { class: "col-sm" }
const _hoisted_89 = {
  key: 8,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_90 = { class: "control-label col-sm-6" }
const _hoisted_91 = { class: "col-sm" }
const _hoisted_92 = {
  key: 9,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_93 = { class: "control-label col-sm-6" }
const _hoisted_94 = { class: "col-sm" }
const _hoisted_95 = {
  key: 10,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_96 = { class: "control-label col-sm-6" }
const _hoisted_97 = { class: "col-sm" }
const _hoisted_98 = {
  key: 11,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_99 = { class: "control-label col-sm-6" }
const _hoisted_100 = { class: "col-sm" }
const _hoisted_101 = {
  key: 12,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_102 = { class: "control-label col-sm-6" }
const _hoisted_103 = { class: "col-sm" }

import { watch , ref, inject } from 'vue'
import { usePreventivo } from '../../composable/usePreventivo';
import FormImmobiliareCasaHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareCasa',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo();
const props = __props;
const testoInfoCompilazione = ref([]);
const emits = __emit;
let validazione;
const validazioneEquoCompenso = ref();
const optionsTipoDiImmobile = ref([
    {name: 'Fabbricato abitativo venduto entro 5 anni da fine lavori', value: 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori'},
    {name: 'Fabbricato abitativo venduto oltre 5 anni da fine lavori', value: 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori'},
    {name: 'Fabbricato abitativo destinato ad alloggio sociale', value: 'fabbricato_abitativo_destinato_ad_alloggio_sociale'},
    {name: 'Fabbricato strumentale venduto entro 5 anni da fine lavori', value: 'fabbricato_strumentale_venduto_entro_5_anni_da_fine_lavori'},
    {name: 'Fabbricato strumentale venduto oltre 5 anni da fine lavori', value: 'fabbricato_strumentale_venduto_oltre_5_anni_da_fine_lavori'},
    {name: 'Fabbricato al grezzo', value: 'fabbricato_al_grezzo'}
  ]);
const { regimeFiscale } = inject('regimeFiscale')
function secondaCasaSelezionato (event) {
  // Alla selezione di seconda casa, DL 73 non è più obbligatorio e ritenuta è ancora abilitato
  // nascondo anche i campi detrazione per credito d'imposta e detrazione per credito preliminare
  if (event.target.checked) {
    validazione.detrazione_credito_imposta.value = '';
    validazione.detrazione_credito_preliminare.value = '';
  }
}
function changeAcquirente(event){
  if(event.target.value == 'soggetto_iva'){
    optionsTipoDiImmobile.value = [
      {name: 'Fabbricato abitativo venduto entro 5 anni da fine lavori', value: 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori'},
      {name: 'Fabbricato abitativo venduto oltre 5 anni da fine lavori', value: 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori'},
      {name: 'Fabbricato strumentale venduto entro 5 anni da fine lavori', value: 'fabbricato_strumentale_venduto_entro_5_anni_da_fine_lavori'},
      {name: 'Fabbricato strumentale venduto oltre 5 anni da fine lavori', value: 'fabbricato_strumentale_venduto_oltre_5_anni_da_fine_lavori'},
      {name: 'Fabbricato al grezzo', value: 'fabbricato_al_grezzo'}
    ]
  } else {
    optionsTipoDiImmobile.value = [
      {name: 'Fabbricato abitativo venduto entro 5 anni da fine lavori', value: 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori'},
      {name: 'Fabbricato abitativo venduto oltre 5 anni da fine lavori', value: 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori'},
      {name: 'Fabbricato abitativo destinato ad alloggio sociale', value: 'fabbricato_abitativo_destinato_ad_alloggio_sociale'},
      {name: 'Fabbricato strumentale venduto entro 5 anni da fine lavori', value: 'fabbricato_strumentale_venduto_entro_5_anni_da_fine_lavori'},
      {name: 'Fabbricato strumentale venduto oltre 5 anni da fine lavori', value: 'fabbricato_strumentale_venduto_oltre_5_anni_da_fine_lavori'},
      {name: 'Fabbricato al grezzo', value: 'fabbricato_al_grezzo'}
    ]
  }
}
switch (props.formName) {
  case 'fabbricatiConPrezzoValore':
    validazione = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiConPrezzoValore'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiConPrezzoValore'];
    break
  case 'fabbricatiSenzaPrezzoValore':
    validazione  = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiSenzaPrezzoValore'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiSenzaPrezzoValore'];
    break
  case 'fabbricatiConIva':
    validazione  = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiConIva'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiConIva'];
    break
  case 'fabbricatiDaSoggettiIva':
    validazione  = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiDaSoggettiIva'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaImmobiliare['sottocategoriaCasa']['fabbricatiDaSoggettiIva'];
    break
}
testoInfoCompilazione.value =  FormImmobiliareCasaHelper.sottocategoriaCasa[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/compravendita/' + props.tipoPreventivo.data.url
}
let indexHelperClosing = {
  calcolo: FormImmobiliareCasaHelper.sottocategoriaCasa[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
watch(validazione, (newValue) => {

  if(props.formName === 'fabbricatiDaSoggettiIva') {
    // controllo per rendere obbligatorio il select opzione iva
    if (newValue.tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
      newValue.impresa_costruttrice.value === 'si' &&
      newValue.acquirente.value !== '' ||
      newValue.tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
      (newValue.impresa_costruttrice.value === 'si' || newValue.impresa_costruttrice.value === 'no') &&
      newValue.acquirente.value === 'privato') {
      newValue.opzione_iva.required = true;
    } else {
      newValue.opzione_iva.required = false;
    }

    if (newValue.tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
      newValue.impresa_costruttrice.value === 'no' &&
      newValue.acquirente.value !== '') {
      validazione.rendite_prima_casa_e_pertinenze_agevolabili.required = true;
    } else {
      validazione.rendite_prima_casa_e_pertinenze_agevolabili.required = false;
    }
  }

  emits('changeDatiPreventivo')
}, { deep: true });

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'fabbricatiConPrezzoValore')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "prezzo",
                name: "prezzo",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).prezzo,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).prezzo) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_prima_casa_e_pertinenze_agevolabili.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "rendite_prima_casa_e_pertinenze_agevolabili",
                name: "rendite_prima_casa_e_pertinenze_agevolabili",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendite_e_pertinenze_non_agevolabili.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_e_pertinenze_non_agevolabili.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_input_text, {
                id: "rendite_e_pertinenze_non_agevolabili",
                name: "rendite_e_pertinenze_non_agevolabili",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendite_e_pertinenze_non_agevolabili,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).rendite_e_pertinenze_non_agevolabili) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
              _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta.ref]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_base_input_text, {
                id: "detrazione_credito_imposta",
                name: "detrazione_credito_imposta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).detrazione_credito_imposta,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).detrazione_credito_imposta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
              _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_base_input_text, {
                id: "detrazione_credito_preliminare",
                name: "detrazione_credito_preliminare",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).detrazione_credito_preliminare,
                "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) === 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(__props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "prezzo",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'fabbricatiSenzaPrezzoValore')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_25, [
                _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_base_input_text, {
                  disabled: __props.readonly,
                  id: "prezzo",
                  name: "prezzo",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  "validate-to": _unref(validazione).prezzo,
                  "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).prezzo) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_28, [
                _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_base_select, {
                  name: "forma_del_titolo",
                  options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                  isSelected: _unref(validazione).forma_del_titolo.value !== '',
                  state: __props.readonly === true ?'disable':'',
                  validateTo: _unref(validazione).forma_del_titolo,
                  "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(validazione).non_agevolato.value == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_31, [
                    _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta.ref]
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_base_input_text, {
                      id: "detrazione_credito_imposta",
                      name: "detrazione_credito_imposta",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).detrazione_credito_imposta,
                      "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).detrazione_credito_imposta) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_base_input_text, {
                  id: "detrazione_credito_preliminare",
                  name: "detrazione_credito_preliminare",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).detrazione_credito_preliminare,
                  "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                _createTextVNode(_toDisplayString(_unref(validazione).non_agevolato.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.non_agevolato.ref]
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_base_input_checkbox, {
                  class: _normalizeClass(__props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                  name: "non_agevolato",
                  onChange: _cache[11] || (_cache[11] = $event => (!props.disabilita ? secondaCasaSelezionato($event) : '')),
                  label: "Si, tassazione non agevolata",
                  "validate-to": _unref(validazione).non_agevolato,
                  "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).non_agevolato) = $event))
                }, null, 8 /* PROPS */, ["class", "validate-to"])
              ])
            ]),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(__props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "prezzo",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'fabbricatiConIva')
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_44, [
                  _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_base_input_text, {
                    id: "prezzo",
                    name: "prezzo",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).prezzo,
                    "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).prezzo) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_47, [
                  _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_base_select, {
                    name: "forma_del_titolo",
                    options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                    isSelected: _unref(validazione).forma_del_titolo.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).forma_del_titolo,
                    "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_50, [
                  _createTextVNode(_toDisplayString(_unref(validazione).non_agevolato.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.non_agevolato.ref]
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_base_input_checkbox, {
                    name: "non_agevolato",
                    class: _normalizeClass(__props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    onChange: _cache[16] || (_cache[16] = $event => (!props.disabilita ? secondaCasaSelezionato($event) : '')),
                    label: "Si, tassazione non agevolata",
                    "validate-to": _unref(validazione).non_agevolato,
                    "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).non_agevolato) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]),
              (_unref(regimeFiscale) == 'ordinario')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_53, [
                      _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(__props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                        name: "ritenuta_acconto",
                        label: "Sì, applica ritenuta d'acconto",
                        "validate-to": _unref(validazione).ritenuta_acconto,
                        "onUpdate:validateTo": _cache[18] || (_cache[18] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                      }, null, 8 /* PROPS */, ["class", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "prezzo",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : (__props.formName === 'fabbricatiDaSoggettiIva')
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_57, [
                    _createTextVNode(_toDisplayString(_unref(validazione).impresa_costruttrice.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.impresa_costruttrice.ref]
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_base_select, {
                      name: "impresa_costruttrice",
                      options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                      isSelected: _unref(validazione).impresa_costruttrice.value != '',
                      state: __props.readonly == true ?'disable':'',
                      validateTo: _unref(validazione).impresa_costruttrice,
                      "onUpdate:validateTo": _cache[19] || (_cache[19] = $event => ((_unref(validazione).impresa_costruttrice) = $event))
                    }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_60, [
                    _createTextVNode(_toDisplayString(_unref(validazione).acquirente.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.acquirente.ref]
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_base_select, {
                      name: "acquirente",
                      options: [{name: 'Privato', value: 'privato'},{name: 'Soggetto I.V.A.', value: 'soggetto_iva'}],
                      isSelected: _unref(validazione).acquirente.value != '',
                      state: __props.readonly == true ?'disable':'',
                      validateTo: _unref(validazione).acquirente,
                      "onUpdate:validateTo": _cache[20] || (_cache[20] = $event => ((_unref(validazione).acquirente) = $event)),
                      onChange: _cache[21] || (_cache[21] = $event => (changeAcquirente($event)))
                    }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_63, [
                    _createTextVNode(_toDisplayString(_unref(validazione).tipo_di_immobile.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_di_immobile.ref]
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_base_select, {
                      name: "tipo_di_immobile",
                      options: optionsTipoDiImmobile.value,
                      isSelected: _unref(validazione).tipo_di_immobile.value != '',
                      state: __props.readonly == true ?'disable':'',
                      validateTo: _unref(validazione).tipo_di_immobile,
                      "onUpdate:validateTo": _cache[22] || (_cache[22] = $event => ((_unref(validazione).tipo_di_immobile) = $event))
                    }, null, 8 /* PROPS */, ["options", "isSelected", "state", "validateTo"])
                  ])
                ]),
                (_unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value !== '' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_66, [
                        _createTextVNode(_toDisplayString(_unref(validazione).opzione_iva.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.opzione_iva.ref]
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_base_select, {
                          name: "opzione_iva",
                          options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                          isSelected: _unref(validazione).opzione_iva.value != '',
                          state: __props.readonly == true ?'disable':'',
                          validateTo: _unref(validazione).opzione_iva,
                          "onUpdate:validateTo": _cache[23] || (_cache[23] = $event => ((_unref(validazione).opzione_iva) = $event))
                        }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          (_unref(validazione).opzione_iva.value === 'si' || _unref(validazione).opzione_iva.value === 'no') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_entro_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_oltre_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
           _unref(validazione).tipo_di_immobile.value === 'fabbricato_al_grezzo' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_69, [
                        _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_base_input_text, {
                          id: "prezzo",
                          name: "prezzo",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).prezzo,
                          "onUpdate:validateTo": _cache[24] || (_cache[24] = $event => ((_unref(validazione).prezzo) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          _unref(validazione).acquirente.value === 'privato' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_72, [
                        _createTextVNode(_toDisplayString(_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_prima_casa_e_pertinenze_agevolabili.ref]
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_base_input_text, {
                          id: "rendite_prima_casa_e_pertinenze_agevolabili",
                          name: "rendite_prima_casa_e_pertinenze_agevolabili",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili,
                          "onUpdate:validateTo": _cache[25] || (_cache[25] = $event => ((_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          _unref(validazione).acquirente.value === 'privato' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_75, [
                        _createTextVNode(_toDisplayString(_unref(validazione).rendite_e_pertinenze_non_agevolabili.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_e_pertinenze_non_agevolabili.ref]
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createVNode(_component_base_input_text, {
                          id: "rendite_e_pertinenze_non_agevolabili",
                          name: "rendite_e_pertinenze_non_agevolabili",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).rendite_e_pertinenze_non_agevolabili,
                          "onUpdate:validateTo": _cache[26] || (_cache[26] = $event => ((_unref(validazione).rendite_e_pertinenze_non_agevolabili) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva')  ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          (_unref(validazione).opzione_iva.value === 'si' || _unref(validazione).opzione_iva.value === 'no') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_entro_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_oltre_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
           _unref(validazione).tipo_di_immobile.value === 'fabbricato_al_grezzo' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_78, [
                        _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createVNode(_component_base_select, {
                          name: "forma_del_titolo",
                          options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                          isSelected: _unref(validazione).forma_del_titolo.value != '',
                          state: __props.readonly == true ?'disable':'',
                          validateTo: _unref(validazione).forma_del_titolo,
                          "onUpdate:validateTo": _cache[27] || (_cache[27] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                        }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          _unref(validazione).acquirente.value === 'privato' ||
          _unref(validazione).non_agevolato.value == false &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_81, [
                        _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta.ref]
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createVNode(_component_base_input_text, {
                          id: "detrazione_credito_imposta",
                          name: "detrazione_credito_imposta",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).detrazione_credito_imposta,
                          "onUpdate:validateTo": _cache[28] || (_cache[28] = $event => ((_unref(validazione).detrazione_credito_imposta) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_84, [
                        _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createVNode(_component_base_input_text, {
                          id: "detrazione_credito_preliminare",
                          name: "detrazione_credito_preliminare",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).detrazione_credito_preliminare,
                          "onUpdate:validateTo": _cache[29] || (_cache[29] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_al_grezzo' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_87, [
                        _createTextVNode(_toDisplayString(_unref(validazione).non_agevolato.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.non_agevolato.ref]
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _createVNode(_component_base_input_checkbox, {
                          class: _normalizeClass(__props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                          name: "non_agevolato",
                          onChange: _cache[30] || (_cache[30] = $event => (!props.disabilita ? secondaCasaSelezionato($event) : '')),
                          label: "Si, tassazione non agevolata",
                          "validate-to": _unref(validazione).non_agevolato,
                          "onUpdate:validateTo": _cache[31] || (_cache[31] = $event => ((_unref(validazione).non_agevolato) = $event))
                        }, null, 8 /* PROPS */, ["class", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_90, [
                        _createTextVNode(_toDisplayString(_unref(validazione).valore_terreno.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_terreno.ref]
                      ]),
                      _createElementVNode("div", _hoisted_91, [
                        _createVNode(_component_base_input_text, {
                          id: "valore_terreno",
                          name: "valore_terreno",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).valore_terreno,
                          "onUpdate:validateTo": _cache[32] || (_cache[32] = $event => ((_unref(validazione).valore_terreno) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_93, [
                        _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_terreno.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_terreno.ref]
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createVNode(_component_base_input_text, {
                          id: "rendita_catastale_terreno",
                          name: "rendita_catastale_terreno",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).rendita_catastale_terreno,
                          "onUpdate:validateTo": _cache[33] || (_cache[33] = $event => ((_unref(validazione).rendita_catastale_terreno) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_96, [
                        _createTextVNode(_toDisplayString(_unref(validazione).terreno_agricolo.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_agricolo.ref]
                      ]),
                      _createElementVNode("div", _hoisted_97, [
                        _createVNode(_component_base_input_checkbox, {
                          class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                          name: "terreno_agricolo",
                          label: "Sì, è agricolo",
                          "validate-to": _unref(validazione).terreno_agricolo,
                          "onUpdate:validateTo": _cache[34] || (_cache[34] = $event => ((_unref(validazione).terreno_agricolo) = $event))
                        }, null, 8 /* PROPS */, ["class", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_99, [
                        _createTextVNode(_toDisplayString(_unref(validazione).terreno_di_pertinenza.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_di_pertinenza.ref]
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _createVNode(_component_base_input_checkbox, {
                          class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                          name: "terreno_di_pertinenza",
                          label: "Sì, è di pertinenza",
                          "validate-to": _unref(validazione).terreno_di_pertinenza,
                          "onUpdate:validateTo": _cache[35] || (_cache[35] = $event => ((_unref(validazione).terreno_di_pertinenza) = $event))
                        }, null, 8 /* PROPS */, ["class", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva')  ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          (_unref(validazione).opzione_iva.value === 'si' || _unref(validazione).opzione_iva.value === 'no') ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_entro_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(regimeFiscale) == 'ordinario' &&
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_oltre_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(regimeFiscale) == 'ordinario' &&
           _unref(validazione).tipo_di_immobile.value === 'fabbricato_al_grezzo' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(regimeFiscale) == 'ordinario' &&
           _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_102, [
                        _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _createVNode(_component_base_input_checkbox, {
                          class: _normalizeClass(__props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                          name: "ritenuta_acconto",
                          label: "Sì, applica ritenuta d'acconto",
                          "validate-to": _unref(validazione).ritenuta_acconto,
                          "onUpdate:validateTo": _cache[36] || (_cache[36] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                        }, null, 8 /* PROPS */, ["class", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(RegimeFiscale, {
                  validazione: _unref(validazione),
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                _createVNode(AliquoteContributiRepertoriali, {
                  validazione: _unref(validazione),
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                (
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_entro_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'privato' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'si' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'si' &&
          _unref(validazione).acquirente.value === 'soggetto_iva' &&
          _unref(validazione).opzione_iva.value === 'no' ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_venduto_oltre_5_anni_da_fine_lavori' &&
          _unref(validazione).impresa_costruttrice.value === 'no' &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_abitativo_destinato_ad_alloggio_sociale' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          _unref(validazione).acquirente.value === 'privato' &&
          (_unref(validazione).opzione_iva.value === 'si' || _unref(validazione).opzione_iva.value === 'no') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_entro_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
          _unref(validazione).tipo_di_immobile.value === 'fabbricato_strumentale_venduto_oltre_5_anni_da_fine_lavori' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva') ||
           _unref(validazione).tipo_di_immobile.value === 'fabbricato_al_grezzo' &&
          (_unref(validazione).impresa_costruttrice.value === 'si' || _unref(validazione).impresa_costruttrice.value === 'no') &&
          (_unref(validazione).acquirente.value === 'privato' || _unref(validazione).acquirente.value === 'soggetto_iva'))
                  ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                      key: 13,
                      "input-riferimento-calcolo": "prezzo",
                      validazione: validazioneEquoCompenso.value,
                      helper: _unref(indexHelperClosing),
                      readonly: __props.readonly
                    }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}